module.exports = __webpack_public_path__ + "static/img/me@2x.69ff0b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/icons/me@2x.png
// module id = 04yV
// module chunks = 1